package com.esoris.kmpmoout.core.koin

import com.esoris.kmpmoout.modules.appModule
import org.koin.core.context.startKoin
import org.koin.core.module.Module
import org.koin.dsl.KoinAppDeclaration

fun initKoin(
    extraModules: List<Module> = emptyList(),
    config: KoinAppDeclaration? = null,
) {

    startKoin {

        config?.invoke(this)

        modules(
            appModule + extraModules
        )

    }

}